import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { QA_NAME_CONFIRMATION } from '../../../constants/qa'
import { ConfirmationModal } from '../../Confirmation'
import { FormModal } from '../../Form'
import { MODAL_HEADER_VARIANT } from '../../Modal'

import { FormFields } from './FormFields'
import { INITIAL_VALUES } from './TableExportGetResponseLinkTypeModal.constants'
import { useExportGetResponseLinkTypeFormSubmit } from './TableExportGetResponseLinkTypeModal.hooks'

function TableExportGetResponseLinkTypeModal({
  errorTextKey = 'Modal.ExportDataErrorMessageKey',
  errorTitleKey = 'Modal.ExportDataErrorTitleKey',
  fieldTitle = 'Table.ExportDataAttentionTextKey',
  headerTitle = 'Table.ExportDataAttentionGetResponseLinkTypeTitleKey',
  qaName,
  onClose,
  ...restProps
}) {
  const { t } = useTranslation()

  const [isLoading, setLoading] = useState(false)
  const [withSubmitButton, setWithSubmitButton] = useState(true)
  const [filesIds, setFilesIds] = useState(null)

  const { handleSubmit } = useExportGetResponseLinkTypeFormSubmit({
    ...restProps,
    onClose,
    onSetFilesIds: setFilesIds,
    onSetLoading: setLoading,
    onSetWithSubmitButton: setWithSubmitButton,
  })

  if (filesIds?.length === 0) {
    return (
      <ConfirmationModal
        actionButtonsProps={{
          Cancel: null,
          submitText: t('Modal.ConfirmBtnKey'),
        }}
        description={t(errorTextKey)}
        qaName={QA_NAME_CONFIRMATION}
        title={t(errorTitleKey)}
        onCancel={onClose}
        onSubmit={onClose}
      />
    )
  }

  return (
    <FormModal
      Fields={FormFields}
      containerProps={{
        headerVariant: MODAL_HEADER_VARIANT.EDIT,
        qaName: qaName,
      }}
      formBodyProps={{
        actionsProps: {
          ...(!withSubmitButton ? { ButtonSubmit: false } : null),
        },
        submitButtonText: 'Modal.ExportDataBtnKey',
      }}
      formFieldsProps={{ fieldTitle, filesIds, isLoading }}
      formTitle={headerTitle}
      initialValues={INITIAL_VALUES}
      onClose={onClose}
      onSubmit={handleSubmit}
    />
  )
}

export default TableExportGetResponseLinkTypeModal
